import { App } from 'antd';

const useApp = () => {
	return {
		// make global Antd message|modal|notification available in the hook
		...App.useApp(),
		// extend with additional properties here
	};
};

export default useApp;
